import React, { useEffect, useState } from 'react'
import OrderStatusSelection from './OrderStatusSelection'

export default function OrderStatusBox({ order, newStatus, enableOrderStatus, onChange }) {
  const [status, setStatus] = useState(order.status)
  useEffect(() => {
    order.isIssue ? setStatus('issue') : setStatus(order.status)
    return () => {}
  }, [order])
  function render(status) {
    switch (status) {
      case 'PENDING':
        return <OrderStatusSelection order={order} defaultStatus={newStatus} onChange={(value) => onChange(value)} />
      case 'CONFIRMED':
        return <OrderStatusSelection order={order} defaultStatus={newStatus} onChange={(value) => onChange(value)} />
      case 'BLOCK':
        return (
          <OrderStatusSelection
            order={order}
            defaultStatus={status !== newStatus ? newStatus : status}
            onChange={(value) => onChange(value)}
          />
        )
      case 'SUCCESS':
        return enableOrderStatus ? (
          <OrderStatusSelection order={order} defaultStatus={newStatus} onChange={(value) => onChange(value)} />
        ) : (
          <span className="text-success">
            ซื้อสำเร็จ {order.approvedBy && <span className="text-info">โดย {order.approvedBy}</span>}
          </span>
        )
      case 'CANCEL':
        return <span className="text-danger">ยกเลิก</span>
      default:
        return <span>ไม่ทราบสถานะ {status}</span>
    }
  }

  return (
    <>
      <div className="d-flex w-100 align-items-center justify-content-between mb-2" style={{ height: '40px' }}>
        <label className="d-flex mb-0" style={{ width: '210px', minWidth: '210px' }}>
          สถานะ :
        </label>
        {render(status)}
      </div>
    </>
  )
}
